import React, { useRef } from 'react'

// style
import { WrapDropdownListFeatureDevice } from './index.styles'

// data
import { dataFeatureDevice } from '../../../../../../data/dataDeviceFeature'
import { useOnClickOutside } from '../../../../../../hook/useClickOutside'
import HandleCallApiLuancherAction from '../HandleCallApiLuancherAction'
import { SCREENSHOT } from '../../../../../../constant/keys'

const DropdownFeatureDevidce = ({ onCloseDropdown, data, checkShowFeatureDevice, isCheckOnClickOutside = true }) => {

    const dropdownRef = useRef(null)

    useOnClickOutside(dropdownRef, () => {
        if(!isCheckOnClickOutside) return
        onCloseDropdown()
    })

    return (
        <WrapDropdownListFeatureDevice ref={dropdownRef}>
            {
                dataFeatureDevice.map((item) => 
                    (
                        checkShowFeatureDevice ? (
                            <div className="feature-item" key={item.id} onClick={HandleCallApiLuancherAction(item.key, [data.serialNumber], item.key === SCREENSHOT ? data.screenShot : data.snapShot, data.facepayApp?.appStatus, data.status)}>
                            {item.isDisable ? item.iconDisable : item.icon}
                            <span className={item.isDisable ? "disable" : ""}>{item.text}</span>
                        </div>
                        ) : (
                            <div className={`feature-item ${!item.isCheckShowFeatureDevice ? 'hide-feature' : ""}`} key={item.id} onClick={HandleCallApiLuancherAction(item.key, data,  data.facepayApp?.appStatus, data.status)}>
                            {item.isDisable ? item.iconDisable : item.icon}
                            <span className={item.isDisable ? "disable" : ""}>{item.text}</span>
                        </div>
                        )
                    )
                )
            }
        </WrapDropdownListFeatureDevice>
    )
}

export default DropdownFeatureDevidce
